import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function GaleriaCuadros() {
  const API = "https://lucianaavalostattoo.com/cuadros_api.php";

  const [cuadros, setCuadros] = useState([]);
  const [loading, setLoading] = useState(true);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(inView);
  }, [inView]);

  const fetchCuadros = async () => {
    try {
      const res = await fetch(`${API}?action=listar`);
      const data = await res.json();
      if (data.ok) setCuadros(data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCuadros();
  }, []);

  // ================= WHATSAPP =================
  const comprar = (c) => {
    const mensaje = `Hola! Quiero comprar este cuadro:\n\n🎨 ${c.titulo}\n💰 Precio: $${c.precio}\n📝 ${c.descripcion || "Sin descripción"}`;
    const url = `https://wa.me/5492235453354?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank");
  };

  // ================= LOADING =================
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5c504b]">
        Cargando...
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
      transition={{ duration: 0.6 }}
      className="w-full min-h-screen flex items-center bg-gradient-to-b from-[#fffdf9] via-[#fef9f3] to-[#f8f3ed] px-4 py-20"
    >
      <div className="max-w-6xl mx-auto w-full text-center">

        {/* TITULO */}
        <h2 className="text-3xl md:text-4xl font-serif text-[#2c2c2c] mb-10">
          Cuadros Disponibles
        </h2>

        {/* SIN CUADROS */}
        {cuadros.length === 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-[#5c504b] text-xl italic"
          >
            Próximamente 🎨
          </motion.div>
        )}

        {/* GRID */}
        <div
          className={`
            grid gap-10
            ${cuadros.length === 1 
              ? "grid-cols-1 justify-items-center" 
              : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"}
          `}
        >
          {cuadros.map((c) => (
            <motion.div
              key={c.id}
              whileHover={{ scale: 1.03 }}
              className="bg-white rounded-3xl shadow-lg p-6 max-w-sm w-full"
            >
              {/* IMAGEN */}
              <div className="bg-[#f8f3ed] rounded-2xl p-4 flex items-center justify-center h-64 mb-4">
                <img
                  src={c.imagen}
                  alt={c.titulo}
                  className="max-h-full max-w-full object-contain"
                />
              </div>

              {/* TEXTO */}
              <h3 className="text-xl font-serif font-bold text-[#2c2c2c]">
                {c.titulo}
              </h3>

              {c.descripcion && (
                <p className="text-[#5c504b] text-sm mt-2 leading-6">
                  {c.descripcion}
                </p>
              )}

              <p className="text-2xl font-bold mt-4 text-[#2c2c2c]">
                ${Number(c.precio).toLocaleString()}
              </p>

              {/* BOTON */}
              <button
                onClick={() => comprar(c)}
                className="mt-5 w-full bg-[#2c2c2c] text-white py-3 rounded-xl hover:opacity-90 transition font-semibold"
              >
                Comprar por WhatsApp
              </button>
            </motion.div>
          ))} 
        </div>
      </div>
    </motion.div>
  );
}